<template>
    <div class="frmszolgkeres_cont">
        <GrcDB ref="GRCDB"></GrcDB>    
        <GrcDialog ref="Dialog"></GrcDialog>

        <div class="frmszolgkeres_input_cont">
            <div class="frmszolgkeres_input_col">
                <GrcText ref="txtNev"
                grc_labeltext="Szolgáltató neve:"
                grc_placeholder=""
                grc_labelmode="above" grc_labelwidth="200px" 
                v-on:grc-keydown-enter="SetControlToFocus('txtCim');"
                style="margin-bottom:20px;"
                />
            </div>
            <div class="frmszolgkeres_input_col">
                <GrcText ref="txtCim"
                grc_labeltext="Cím (pl. város vagy ir. szám):"
                grc_placeholder=""
                grc_labelmode="above" grc_labelwidth="200px" 
                v-on:grc-keydown-enter="SetControlToFocus('');"
                style="margin-bottom:20px;"
                />
            </div>
            <div class="frmszolgkeres_btncont">
                <span class="painted_linkbutton color3" @click="btnKeres_click"><span><i class="fal fa-search" style="margin-right:10px;"></i>Keresés</span></span>
            </div>
        </div>



        <div class="frmszolgkeres_list_cont">
            <div class="frmszolgkeres_list_resultinfo" v-show="IsFirstView">Kérem adja meg a feltételeket, majd kattintson a "Keresés" gombra!</div>
            <div class="frmszolgkeres_list_resultinfo" v-show="(IsFirstView==false)&&(LIST.length==0)">Nincs a keresésnek megfelelő szolgáltató!</div>

            <div class="frmszolgkeres_list_col" v-for="(item, index) in LIST" :key="index">
                <div class="frmszolgkeres_list_item_nev">{{item.Nev}}</div>
                <div class="frmszolgkeres_list_item_egyeb">{{item.Cim}}</div>
                <div class="frmszolgkeres_list_item_egyeb" v-show="item.Telefon!=''"><i class="fal fa-phone" style="margin-right:10px;"></i>{{item.Telefon}}</div>
                <div class="frmszolgkeres_list_item_egyeb" v-show="item.Email!=''"><i class="fal fa-envelope" style="margin-right:10px;"></i>{{item.Email}}</div>
                <div class="frmszolgkeres_list_item_egyeb" v-show="item.OnlineFoglalas!=''"><i class="fal fa-calendar-check" style="margin-right:10px;"></i>{{item.OnlineFoglalas}}</div>
                
                <div style="width:100%; box-sizing:border-box; font-size:1px; line-height:1px; margin-bottom:8px;">&nbsp;</div>

                <span class="painted_linkbutton2 color4" @click="btnShowMap_click(index)"><span><i class="fal fa-route" style="margin-right:10px;"></i>Térkép</span></span>
                <span class="painted_linkbutton2 color6" @click="btnShowWebsite_click(index)" v-show="item.Weboldal!=''"><span><i class="fal fa-globe" style="margin-right:10px;"></i>Weboldal</span></span>
            </div>
        </div>

    </div>
</template>

<script>

import GrcText from '../GrcComponents/GrcText.vue'
import GrcButton from '../GrcComponents/GrcButton.vue'
import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcDialog from '../GrcComponents/GrcDialog.vue'
import GrcCheckboxMobile from '../GrcComponents/GrcCheckboxMobile.vue'


export default {
  name: 'frmszolgkeres',
  components: {
      GrcText,
      GrcButton,
      GrcDB,
      GrcDialog,
      GrcCheckboxMobile
  },
  props: {
  },
  data () {
      return {
          WSPREFIX: "frmszolgkeres_",

          LIST: [],

          IsFirstView: true,

      }
  },
  model: {

  },  
  methods:{

    GetTextBookItem(pCompName)
    {
        return grcmain_GetTextBookItem("frmlogin", pCompName);
    },

    SetLang()
    {
        //this.Kereses();
    },



    SetControlToFocus(pNextComp)
    {
        if (pNextComp == "") { return; }
        this.$refs[pNextComp].SetFocus();
    },


    btnShowMap_click(pIndex)
    {

        let s = this.LIST[pIndex].MapsCim;

        window.open("https://maps.google.com?q="+s);

    },

    btnShowWebsite_click(pIndex)
    {

        let s = this.LIST[pIndex].Weboldal;

        window.open(s);

    },

    btnKeres_click()
    {
        this.Kereses();
    },

    async Kereses()
    {
        let pNev = this.$refs.txtNev.GetText().trim();
        let pCim = this.$refs.txtCim.GetText().trim();

        this.$refs.GRCDB.ShowLoading(false);

        var QP = { 
            sNev: pNev,
            sCim: pCim
        };

        var Q;
        await this.$refs.GRCDB.GetData("ELLA_SzolgKeres", QP).then(res => { Q = res; });

        //console.log(Q);

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            this.$emit("handlecommerror", Q.APPERR[0].ERR);
            return;
        }

        this.$refs.GRCDB.HideLoading();

        this.IsFirstView = false;

        this.LIST = Q.DETAILDATA;


    },



  },
  created()
  {

  },
  mounted()
  {
    this.SetLang();

    if (gAppInitDone)
    {
      if (grcmain_GetAppTypeID() != 0)
      {
        gRouteMode = "replace";
        this.$emit("navigate", "default");
      }
    }
  }

}


</script>


<style scoped>

.frmszolgkeres_cont
{
    width:100%;
    box-sizing: border-box;
    text-align:left;
    display:block;
}

.frmszolgkeres_input_cont
{
    width:100%;
    box-sizing: border-box;
    display:block;
    padding-bottom: 20px;
    margin-bottom:20px;
}

.frmszolgkeres_input_col
{
    width: calc(50% - 90px);
    box-sizing: border-box;
    display: inline-block;
    padding: 4px;
    vertical-align: top;
}

.frmszolgkeres_btncont
{
    width:180px;
    display: inline-block;
    vertical-align: top;
    padding-top: 26px;
    text-align: center;    
}


.frmszolgkeres_list_cont
{
    width:100%;
    box-sizing: border-box;
    display:block;
}

.frmszolgkeres_list_col
{
    width: calc(50% - 90px);
    box-sizing: border-box;
    display: inline-block;
    padding: 16px 4px;
    vertical-align: top;
    border-top: solid 0px #ccc;
}

.frmszolgkeres_list_item_nev
{
    width:100%;
    text-align:left;
    font-weight:500;
    font-size:18px;
    line-height: 26px;
    color:var(--themecolor3);
}

.frmszolgkeres_list_item_egyeb
{
    width:100%;
    text-align:left;
    font-weight:500;
    font-size:16px;
    line-height: 22px;
    color:var(--themecolor1);
}

.frmszolgkeres_list_resultinfo
{
    width:100%;
    box-sizing: border-box;
    text-align: center;
    font-size: 16px;
    line-height: 22px;
    color: var(--themecolor1);
    font-weight: 500;
    padding:10px 4px;
    border-top: solid 0px #ccc;    
}

@media(max-width:900px)
{
    .frmszolgkeres_list_col
    {
        width:100%;
    }    

    .frmszolgkeres_input_col
    {
        width:100%;
    }

    .frmszolgkeres_btncont
    {
        width:100%;
        padding-top: 0px;
    }

}



</style>